/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Bin = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 17 21">
      <path
        d="M12.7054 0.229383C13.1517 0.551883 13.3167 1.13688 13.1142 1.64688L10.1742 9.00063H15.6004C16.1067 9.00063 16.5567 9.31563 16.7292 9.79188C16.9017 10.2681 16.7554 10.8006 16.3692 11.1231L5.56916 20.1231C5.14541 20.4756 4.54166 20.4944 4.09541 20.1719C3.64916 19.8494 3.48416 19.2644 3.68666 18.7544L6.62666 11.4006H1.20041C0.694159 11.4006 0.244159 11.0856 0.0716588 10.6094C-0.100841 10.1331 0.0454087 9.60063 0.431659 9.27813L11.2317 0.278133C11.6554 -0.0743672 12.2592 -0.0931174 12.7054 0.229383Z"
        fill="#000"
      />
    </BaseSvgIcon>
  )
}

export default Bin
